const accountsURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_ACCOUNTS}`;
export const Comments = `${accountsURL}/comments`;
export const AUDITS_EVENT = `${accountsURL}/scheduler/events`;
export const UPDATE_SCHEDULER = `${accountsURL}/scheduler/update`;
export const MilestoneDetails = `${accountsURL}/milestonestatus`;
export const OcComments = `${accountsURL}/device-level-updates/comments`;
export const LOOKUP_REVEAL_ACCOUNT_STATUS = `${process.env.REACT_APP_BASE_URL}sfdc/api/v1/account/accountNumber`;
export const ACCOUNT_SUSPEND_ACTION_BASE = `${accountsURL}/account-suspend`;
export const CREATE_ACCOUNT_LOOKUP = `${accountsURL}/create/account/prefill`;
export const CREATE_ACCOUNT_REVEAL = `${accountsURL}/create/account/legacy`;